import Image from "next/image"
import { cn } from "@/lib/utils"
import { AVATAR_PLACEHOLDER } from "@/lib/constant"

interface UserAvatarProps {
    avatarUrl: string | null | undefined
    size?: number
    className?: string
}

export default function UserAvatar({avatarUrl,className,size}: UserAvatarProps){
    return <Image src={avatarUrl ?? AVATAR_PLACEHOLDER} alt="User avatar" width={size ?? 48} height={size ?? 48} loading="lazy" quality={50} className={cn("aspect-square h-fit flex-none rounded-full bg-custom-secondary object-cover", className)}/>
}